import styled from 'styled-components'

const SidebarFooter = styled.div`

`

export default SidebarFooter